import React, { useEffect, useState } from 'react';
import { fetchCurrentTerms } from './reservationApi';
import './Terms.css';

function Terms() {
  const [terms, setTerms] = useState(null);
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    fetchCurrentTerms()
      .then((current) => {
        if (!cancelled) {
          setTerms(current);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setLoadFailed(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (loadFailed) {
    return (
      <section className="terms">
        <h1>Terms and Conditions</h1>
        <p role="alert">
          We could not load the Terms and Conditions right now. Please try again, or contact us
          before submitting a reservation request.
        </p>
      </section>
    );
  }

  if (!terms) {
    return (
      <section className="terms">
        <h1>Terms and Conditions</h1>
        <p>Loading...</p>
      </section>
    );
  }

  return (
    <section className="terms">
      <h1>Terms and Conditions</h1>

      <p className="terms__version">
        Version {terms.version}. The version you accept is recorded with your reservation
        request.
      </p>

      {terms.sections.map((section, index) => (
        <article key={section.heading}>
          <h2>
            {index + 1}. {section.heading}
          </h2>
          <p>{section.body}</p>
        </article>
      ))}

      <p>
        Questions about any of this? Contact Modern Cars LLC before submitting a reservation
        request.
      </p>
    </section>
  );
}

export default Terms;
